import React from 'react';
import Label from "components/Form/Label";
import {concatenate} from "services/string";
import {LabelColor} from "../Label/Label";

type Props = {
    label?: string
    hint?: string
    fieldId?: string
    condensed?: boolean
    children?: React.ReactNode
    labelColor?: LabelColor
}

function FieldHeader(props: Props) {
    const {label, hint, fieldId, condensed, children, labelColor} = props

    return (
        <div className={concatenate(!(label || children)? 'flex-row-reverse' : null, condensed? 'space-x-2' : 'justify-between', 'flex')}>
            {(label || children) && fieldId &&
                <Label htmlFor={fieldId} color={labelColor}>
                    {children || label}
                </Label>
            }

            {(label || children) && !fieldId &&
                <span className="block text-sm font-medium text-gray-700">
                    {children || label}
                </span>
            }

            {hint &&
                <span className="text-sm text-gray-500">
                    {hint}
                </span>
            }
        </div>
    );
}

export default FieldHeader;